package com.devi3east.bashbuddy.purchase.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class OrgSubPurchase(
    val organizationId: String,
    val eventId: String,
    val connectedAccountId: String,
    val status: SubPurchaseStatus? = null,
    val checkoutSessionId: String? = null,
    val checkoutSessionUrl: String? = null,
    val applicationFeeCents: Long,
    val subtotalCents: Long? = null,
    val totalCents: Long,
    val items: List<PurchasedTicketItem> = emptyList(),
    val pendingActions: Int
)